export class ModifiedArray<T> extends Array<T> {
  findByField(field: keyof T, value: any): T | undefined {
    return this.find((item) => item[field] === value);
  }
}
